// Light or dark, chosen in Settings → Appearance. A choice for this browser only, kept in
// localStorage; light unless someone picks otherwise. Automatic follows the system setting,
// and keeps following it while the page is open.

export type ThemeChoice = 'light' | 'dark' | 'auto'

const KEY = 'ice.theme'
const system = window.matchMedia('(prefers-color-scheme: dark)')

export function themeChoice(): ThemeChoice {
  try {
    const saved = localStorage.getItem(KEY)
    if (saved === 'light' || saved === 'dark' || saved === 'auto') return saved
  } catch {
    // Storage can be blocked (private windows, site data off). Light, then.
  }
  return 'light'
}

function apply(choice: ThemeChoice) {
  const dark = choice === 'dark' || (choice === 'auto' && system.matches)
  if (dark) document.documentElement.dataset.theme = 'dark'
  else delete document.documentElement.dataset.theme
}

export function setThemeChoice(choice: ThemeChoice) {
  try {
    localStorage.setItem(KEY, choice)
  } catch {
    // Still applies for this visit.
  }
  apply(choice)
}

/** Called once, before the first render. */
export function startTheme() {
  apply(themeChoice())
  system.addEventListener('change', () => {
    if (themeChoice() === 'auto') apply('auto')
  })
}
